import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { FiChevronDown } from "react-icons/fi";
import { Text } from "~/components/Text";

type Faq = {
  id: string;
  label: string;
  answer: string;
};

type FaqsProps = {
  faqs: Faq[];
};

export function Faqs({ faqs }: FaqsProps) {
  if (faqs.length === 0) return null;

  return (
    <div className="flex flex-col divide-y divide-butter-green/15 border-y border-butter-green/15">
      {faqs.map((faq) => (
        <Disclosure key={faq.id} as="div">
          {({ open }) => (
            <>
              <DisclosureButton className="group flex w-full items-center justify-between gap-3 py-4 text-left">
                <Text as="span" variant="secondary" size="md" weight="bold">
                  {faq.label}
                </Text>
                <FiChevronDown
                  size={18}
                  className={`flex-shrink-0 text-butter-green transition-transform ${
                    open ? "rotate-180" : ""
                  }`}
                  aria-hidden
                />
              </DisclosureButton>
              <DisclosurePanel className="pb-4">
                <Text
                  variant="secondary"
                  size="md"
                  className="whitespace-pre-line leading-relaxed"
                >
                  {faq.answer}
                </Text>
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  );
}
